import { Box, TableCell } from '@mui/material';
import { styled } from 'styled-components';

export const RowContainerSpaceBetween = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

export const TableCellHeader = styled(TableCell)`
  white-space: nowrap;
  padding: 0px 2px;
  border: 2px solid #000;

  font-weight: 700;

  //desabilitar a borda do primeiro e do ultimo item
  &:first-child {
    border-left: 0;
  }
  &:last-child {
    border-right: 0;
  }
`;

export const TableCellBody = styled(TableCell)`
  white-space: nowrap;
  padding: 0px 2px;
  border: 1px solid #000;

  //desabilitar a borda do primeiro e do ultimo item
  &:first-child {
    border-left: 0;
  }
  &:last-child {
    border-right: 0;
  }
`;
